export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'campus', name: '校园', icon: 'ri-building-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-4-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-user-heart-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
];

export const comics = [
  {
    id: 1,
    title: '绝世神医',
    author: '李明浩',
    category: 'fantasy',
    status: '连载中',
    rating: 9.5,
    views: 1285000,
    description: '天才医学生穿越异世，凭借超凡医术逆天改命，成为一代绝世神医。在充满奇幻与危险的世界中，他用银针为剑，以草药为盾，书写了一段传奇人生。',
    chapters: 156,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20art%20style%2C%20beautiful%20character%20illustration%20with%20soft%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20vibrant%20colors%20with%20elegant%20composition%2C%20vertical%20poster%20format&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20minimalist%20style%2C%20single%20character%20portrait%20with%20soft%20lighting%2C%20clean%20design&width=120&height=160&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '霸道总裁的小娇妻',
    author: '金秀雅',
    category: 'romance',
    status: '已完结',
    rating: 9.2,
    views: 2560000,
    description: '普通女孩意外与霸道总裁签订契约婚姻，从互不顺眼到暗生情愫。当真相揭开，她才发现这场婚姻背后隐藏着不为人知的秘密……',
    chapters: 98,
    updateDate: '2026-07-28',
    coverUrl: 'https://readdy.ai/api/search-image?query=Romance%20Korean%20manhwa%20cover%20art%20style%2C%20beautiful%20couple%20illustration%20with%20soft%20romantic%20lighting%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20vibrant%20warm%20colors%20with%20elegant%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Romance%20Korean%20manhwa%20cover%20art%2C%20single%20female%20character%20portrait%2C%20soft%20lighting&width=120&height=160&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: 'thriller',
    status: '连载中',
    rating: 9.7,
    views: 1890000,
    description: '前刑警因一桩悬案被卷入连环杀人事件，每一个线索都指向一个更大的阴谋。在追查真相的过程中，他发现凶手似乎就在自己身边……',
    chapters: 72,
    updateDate: '2026-08-03',
    coverUrl: 'https://readdy.ai/api/search-image?query=Thriller%20Korean%20manhwa%20cover%20art%20style%2C%20mysterious%20dark%20atmosphere%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20deep%20colors%20with%20dramatic%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Thriller%20Korean%20manhwa%20cover%2C%20dark%20mysterious%20character%20portrait%2C%20dramatic%20lighting&width=120&height=160&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '校园风云录',
    author: '崔智恩',
    category: 'campus',
    status: '连载中',
    rating: 9.0,
    views: 965000,
    description: '转学生意外成为校园风云人物，友情、爱情、梦想在青春的校园里交织。面对种种挑战，他和朋友们一起成长，找到了属于自己的道路。',
    chapters: 134,
    updateDate: '2026-08-02',
    coverUrl: 'https://readdy.ai/api/search-image?query=Campus%20Korean%20manhwa%20cover%20art%20style%2C%20youthful%20school%20life%20character%20illustration%2C%20bright%20fresh%20design%2C%20modern%20webtoon%20aesthetic%2C%20vibrant%20colors%20with%20energetic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Campus%20Korean%20manhwa%20cover%2C%20youthful%20student%20character%20portrait%2C%20bright%20lighting&width=120&height=160&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '龙之继承者',
    author: '郑宇成',
    category: 'fantasy',
    status: '连载中',
    rating: 9.8,
    views: 3200000,
    description: '平凡少年意外觉醒了龙族血脉，从此踏上修炼之路。在强敌环伺的世界中，他必须不断变强，守护自己珍视的一切，成为真正的龙之继承者。',
    chapters: 210,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20cover%20art%20style%2C%20heroic%20dragon%20theme%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20vibrant%20golden%20colors%20with%20majestic%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20cover%2C%20heroic%20character%20portrait%2C%20golden%20lighting&width=120&height=160&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '都市猎魔人',
    author: '韩泰俊',
    category: 'action',
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    description: '隐藏在都市中的猎魔人组织，专门处理超自然事件。主角身为最年轻的S级猎魔人，在保护城市的同时，也在追查父母失踪的真相。',
    chapters: 88,
    updateDate: '2026-08-01',
    coverUrl: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manhwa%20cover%20art%20style%2C%20cool%20urban%20hunter%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20dynamic%20colors%20with%20action%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manhwa%20cover%2C%20cool%20character%20portrait%2C%20dynamic%20lighting&width=120&height=160&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '星河之恋',
    author: '尹素熙',
    category: 'romance',
    status: '已完结',
    rating: 9.4,
    views: 2100000,
    description: '天文学家和偶像歌手因为一次观星活动意外相遇，来自两个截然不同世界的人，在星光下谱写了一段跨越阶层的浪漫爱情故事。',
    chapters: 120,
    updateDate: '2026-07-15',
    coverUrl: 'https://readdy.ai/api/search-image?query=Starry%20romance%20Korean%20manhwa%20cover%20art%20style%2C%20dreamy%20couple%20under%20stars%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20soft%20blue%20tone%20colors%20with%20romantic%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Starry%20romance%20Korean%20manhwa%20cover%2C%20dreamy%20character%20portrait%2C%20soft%20blue%20lighting&width=120&height=160&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '末日生存法则',
    author: '张东健',
    category: 'action',
    status: '连载中',
    rating: 9.6,
    views: 2750000,
    description: '末日降临，丧尸横行。一群幸存者在废墟中建立据点，为了生存不断战斗。在这残酷的世界中，人性的善与恶被展现得淋漓尽致。',
    chapters: 165,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Korean%20manhwa%20cover%20art%20style%2C%20survival%20theme%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20dark%20desaturated%20colors%20with%20dramatic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Korean%20manhwa%20cover%2C%20survival%20character%20portrait%2C%20dark%20dramatic%20lighting&width=120&height=160&seq=comic-cover-08&orientation=portrait',
  },
  {
    id: 9,
    title: '长安幻夜',
    author: '韩雪儿',
    category: 'historical',
    status: '已完结',
    rating: 9.5,
    views: 1430000,
    description: '大唐盛世，长安城中暗流涌动。一位身世成谜的少女卷入了宫廷与江湖的纷争之中，在权谋与情义之间做出了自己的选择。',
    chapters: 86,
    updateDate: '2026-06-30',
    coverUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20Tang%20dynasty%20Korean%20manhwa%20cover%20art%20style%2C%20elegant%20ancient%20beauty%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20classical%20red%20and%20gold%20colors&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Historical%20Korean%20manhwa%20cover%2C%20elegant%20ancient%20character%20portrait%2C%20classical%20lighting&width=120&height=160&seq=comic-cover-09&orientation=portrait',
  },
  {
    id: 10,
    title: '心动信号',
    author: '李智慧',
    category: 'bl',
    status: '连载中',
    rating: 9.1,
    views: 890000,
    description: '两个性格迥异的男生从互看不顺眼到逐渐理解对方，在青春最美好的时光里，一段细腻温暖的纯爱故事悄然展开。',
    chapters: 64,
    updateDate: '2026-08-03',
    coverUrl: 'https://readdy.ai/api/search-image?query=BL%20Korean%20manhwa%20cover%20art%20style%2C%20warm%20tender%20couple%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20soft%20pastel%20colors%20with%20sweet%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=BL%20Korean%20manhwa%20cover%2C%20warm%20tender%20character%20portrait%2C%20soft%20pastel%20lighting&width=120&height=160&seq=comic-cover-10&orientation=portrait',
  },
  {
    id: 11,
    title: '搞笑一家人',
    author: '金光洙',
    category: 'comedy',
    status: '连载中',
    rating: 9.3,
    views: 1100000,
    description: '一个普通家庭的爆笑日常，每个家庭成员都有自己的小秘密和奇葩爱好。在欢笑与泪水中，展现了最真实的家庭温情。',
    chapters: 200,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Comedy%20Korean%20manhwa%20cover%20art%20style%2C%20funny%20family%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20bright%20cheerful%20colors%20with%20playful%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Comedy%20Korean%20manhwa%20cover%2C%20funny%20character%20portrait%2C%20bright%20cheerful%20lighting&width=120&height=160&seq=comic-cover-11&orientation=portrait',
  },
  {
    id: 12,
    title: '职场女王',
    author: '朴恩静',
    category: 'urban',
    status: '连载中',
    rating: 9.0,
    views: 780000,
    description: '职场新人从菜鸟到总监的逆袭之路，在竞争激烈的都市职场中，她用智慧和勇气杀出一条血路，成为真正的职场女王。',
    chapters: 92,
    updateDate: '2026-08-02',
    coverUrl: 'https://readdy.ai/api/search-image?query=Office%20drama%20Korean%20manhwa%20cover%20art%20style%2C%20professional%20woman%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20sophisticated%20neutral%20colors%20with%20confident%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Office%20Korean%20manhwa%20cover%2C%20professional%20woman%20portrait%2C%20sophisticated%20lighting&width=120&height=160&seq=comic-cover-12&orientation=portrait',
  },
  {
    id: 13,
    title: '深海之谜',
    author: '吴世勋',
    category: 'thriller',
    status: '连载中',
    rating: 9.4,
    views: 1350000,
    description: '深海勘探队在海底发现了一座神秘古城，接踵而至的超自然现象让队员们陷入恐惧。这座古城隐藏着人类未知的秘密……',
    chapters: 55,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Deep%20sea%20mystery%20Korean%20manhwa%20cover%20art%20style%2C%20mysterious%20underwater%20theme%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20deep%20ocean%20blue%20colors%20with%20mysterious%20composition&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Deep%20sea%20Korean%20manhwa%20cover%2C%20mysterious%20character%20portrait%2C%20deep%20blue%20lighting&width=120&height=160&seq=comic-cover-13&orientation=portrait',
  },
  {
    id: 14,
    title: '花美男咖啡厅',
    author: '刘彩英',
    category: 'campus',
    status: '已完结',
    rating: 8.9,
    views: 670000,
    description: '大学附近的一家神秘咖啡厅，里面的服务生全都是花美男。女主为了还债在这里打工，却意外收获了友情和爱情。',
    chapters: 76,
    updateDate: '2026-05-20',
    coverUrl: 'https://readdy.ai/api/search-image?query=Cafe%20romance%20Korean%20manhwa%20cover%20art%20style%2C%20handsome%20barista%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20warm%20coffee%20tone%20colors%20with%20cozy%20composition&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cafe%20Korean%20manhwa%20cover%2C%20handsome%20character%20portrait%2C%20warm%20cozy%20lighting&width=120&height=160&seq=comic-cover-14&orientation=portrait',
  },
  {
    id: 15,
    title: '魔剑士传说',
    author: '安宰贤',
    category: 'fantasy',
    status: '连载中',
    rating: 9.6,
    views: 1980000,
    description: '在魔法与剑并存的异世界中，一个废柴少年意外获得了传说中的魔剑。从此，他的命运发生了翻天覆地的变化，一段波澜壮阔的冒险开始了。',
    chapters: 178,
    updateDate: '2026-08-04',
    coverUrl: 'https://readdy.ai/api/search-image?query=Magic%20sword%20fantasy%20Korean%20manhwa%20cover%20art%20style%2C%20heroic%20warrior%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20magical%20purple%20tone%20colors%20with%20epic%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Magic%20sword%20Korean%20manhwa%20cover%2C%20heroic%20warrior%20portrait%2C%20epic%20magical%20lighting&width=120&height=160&seq=comic-cover-15&orientation=portrait',
  },
  {
    id: 16,
    title: '古墓奇谈',
    author: '沈银河',
    category: 'historical',
    status: '已完结',
    rating: 9.2,
    views: 1020000,
    description: '考古系研究生在一座千年古墓中发现了不可思议的秘密，古人的智慧远超想象。一场跨越时空的探索之旅就此展开。',
    chapters: 68,
    updateDate: '2026-04-12',
    coverUrl: 'https://readdy.ai/api/search-image?query=Ancient%20tomb%20mystery%20Korean%20manhwa%20cover%20art%20style%2C%20archaeological%20adventure%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20ancient%20earthy%20colors%20with%20mysterious%20composition&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Ancient%20tomb%20Korean%20manhwa%20cover%2C%20archaeological%20character%20portrait%2C%20mysterious%20ancient%20lighting&width=120&height=160&seq=comic-cover-16&orientation=portrait',
  },
];

export const getComicsByCategory = (slug: string) => {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.category === slug);
};

export const getComicById = (id: number) => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = () => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
};

export const getNewComics = () => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);
};

export const getTopRatedComics = () => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);
};